/*=========================================================================================
  File Name: moduleAuthGetters.js
  Description: Auth Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import get from 'lodash.get'
const getters = {
    getAppActiveUser: (state) => {
        if (get(state, 'user.id')  && get(state, 'user.info.username'))
            return state.user
        return false
    }
}

export default getters



